module.exports = __webpack_public_path__ + "static/media/trello-logo.0099ec37.png";


//////////////////
// WEBPACK FOOTER
// ./src/trello-logo.png
// module id = 38
// module chunks = 0